import { useEffect, useRef } from 'react';

function useInterval(callback, delay, startWithZeroTime=false) {
  const savedCallback = useRef();
  const savedId = useRef();

  // Remember the latest callback.
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Set up the interval.
  useEffect(() => {
    function tick() {
      savedCallback.current();
    }
    if (delay !== null) {
      if(startWithZeroTime) tick();
      savedId.current = setInterval(tick, delay);
    } else {
      clearInterval(savedId.current)
    }

    return () => clearInterval(savedId.current);
  }, [delay, startWithZeroTime]);
}

export default useInterval;
